import React, { useEffect, useState } from 'react'
import { Menu, MenuButton, MenuButtonProps, MenuList, Portal, Text, useDisclosure } from '@chakra-ui/react'
import DateSelector from './DateSelector'
import { getFormatterDateRange, getLastDaysDateRange, getParseDate } from '../../routes/home/util/GetDateRangeUtil';

interface DynamicDateRangeProps extends MenuButtonProps {
  onDateRangeChange: (range: DateRange) => void,
  startDate?: string,
  endDate?: string,
  useDefaultDates?: boolean,
  // Si se indica, el rango por defecto (y "Limpiar") son los últimos N días; si no, el último mes.
  defaultRangeDays?: number,
}

export interface DateRange {
  startDate: Date | undefined,
  endDate: Date | undefined
}



export const DynamicDateRange = ({ onDateRangeChange, startDate = undefined, endDate = undefined, useDefaultDates = true, defaultRangeDays, ...props }: DynamicDateRangeProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const getInitialDateRange = () => {
    if (useDefaultDates && defaultRangeDays) {
      return getLastDaysDateRange(defaultRangeDays);
    }
    if (useDefaultDates) {
      const today = new Date();
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(today.getMonth() - 1);
      return {
        startDate: oneMonthAgo,
        endDate: today
      };
    }
    return {
      startDate: undefined,
      endDate: undefined
    };
  };

  const initialDateRange = getInitialDateRange();
  const [dateRange, setDateRange] = useState<DateRange>(initialDateRange);
  const [labelDateRange, setLabelDateRange] = useState<string>('');

  useEffect(() => {
    if (startDate || endDate) {
      setDateRange({
        startDate: startDate ? getParseDate(startDate) : undefined,
        endDate: endDate ? getParseDate(endDate) : undefined
      });
    } else {
      setDateRange(getInitialDateRange());
    }
  }, [startDate, endDate, useDefaultDates, defaultRangeDays]);

  useEffect(() => {
    formatDates()
  }, [dateRange.startDate, dateRange.endDate]);

  const handleOnChangeDates = (dates: any) => {
    const [startDate, endDate] = dates
    setDateRange({ startDate, endDate })
  }

  const handleClear = () => {
    setDateRange(getInitialDateRange());
    onDateRangeChange(getInitialDateRange());
  }

  const handleApply = () => {
    onDateRangeChange(dateRange)
    onClose()
  }

  const formatDates = () => {
    const { startDate, endDate } = getFormatterDateRange(dateRange.startDate, dateRange.endDate)
    setLabelDateRange(`${startDate}  -  ${endDate}`)
  }

  return <>
    <Menu isOpen={isOpen} onClose={onClose}>
      <MenuButton px="xxl" py="1.1em" height="1em" borderWidth={1} borderRadius="md" onClick={onOpen} {...props}>
        <Text color="neutral.600" fontWeight="thin" py="0">{labelDateRange} </Text>
      </MenuButton>
      <Portal>
        <MenuList zIndex="popover" css={{ '.react-datepicker__day--outside-month': { visibility: 'hidden' } }}>
          <DateSelector
            startDate={dateRange.startDate}
            endDate={dateRange.endDate}
            handleOnChangeDates={handleOnChangeDates}
            handleClear={handleClear}
            handleApply={handleApply} />
        </MenuList>
      </Portal>
    </Menu>
  </>
}
